// src/hooks/useSmsUnreadCount.ts
// Total unread SMS across all conversations (crm_contacts.unread_count where
// the contact has a phone). Powers the Conversations nav badge.
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabaseClient';
import { useAuth } from '@/contexts/AuthContext';

export function useSmsUnreadCount(): number {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ['sms-unread-total', user?.id],
    enabled: !!user?.id,
    refetchInterval: 20000,
    refetchOnWindowFocus: true,
    queryFn: async (): Promise<number> => {
      const { data: rows, error } = await supabase
        .from('crm_contacts')
        .select('unread_count')
        .not('phone', 'is', null)
        .gt('unread_count', 0);
      if (error) throw error;
      return (rows ?? []).reduce((sum, r) => sum + (r.unread_count ?? 0), 0);
    },
  });
  return data ?? 0;
}
